import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DonorListComponent } from './donor-list/donor-list.component';
import { DonorRoutingModule } from './donor-routing.module';
import { SharedModule } from '../shared/shared.module';
import { DonorDetailsComponent } from './donor-details/donor-details.component';
import { ReactiveFormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    DonorListComponent,
    DonorDetailsComponent
  ],
  imports: [
    CommonModule,
    DonorRoutingModule,
    SharedModule,    
    ReactiveFormsModule,
  ]
})
export class DonorModule { }
